import { colors } from '../../../utilities/colors'

export const VEHICLE_STATUSES = [
  'ordered',
  'carrier_assigned',
  'driver_assigned',
  'pick_up_enroute',
  'arrived_at_pickup',
  'picked_up',
  'delivery_enroute',
  'arrived_at_delivery',
  'delivered',
  'payment_approved',
  'payment_rejected',
  'paid',
  'qualifying',
  'hold',
  'canceled',
]

const VEHICLE_STATUS_COLOR = {
  ordered: '#4A90D9',
  carrier_assigned: '#4A90D9',
  driver_assigned: '#4A90D9',
  qualifying: '#4A90D9',
  pick_up_enroute: colors.yellow,
  arrived_at_pickup: colors.yellow,
  picked_up: colors.yellow,
  delivery_enroute: colors.yellow,
  arrived_at_delivery: colors.yellow,
  delivered: colors.green,
  payment_approved: colors.green,
  paid: colors.green,
  payment_rejected: colors.fpxRed,
  hold: colors.fpxRed,
  canceled: colors.fpxRed,
  cancelled: colors.fpxRed,
  dry_run: colors.fpxRed,
}

export const vehicleStatusColor = (status) => VEHICLE_STATUS_COLOR[status] || colors.grey300

const CANCELABLE_BEFORE_STATUS = 'pick_up_enroute'

const isVehicleCancelable = (status) => {
  const statusIndex = VEHICLE_STATUSES.indexOf(status)
  const cutoffIndex = VEHICLE_STATUSES.indexOf(CANCELABLE_BEFORE_STATUS)
  return statusIndex !== -1 && statusIndex < cutoffIndex
}

export const isVehicleCanceled = (status) => status === 'canceled' || status === 'cancelled'

export const isCarpoolOrderCancelable = (order) => {
  const vehicles = order?.attributes?.['response-cache']?.vehicles || []
  if (vehicles.length === 0) return false
  return vehicles.every((vehicle) => isVehicleCancelable(vehicle.status))
}
